import React, { useEffect } from "react";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// hooks
import useApiStatus from "frontend/hooks/useApiStatus";

// components
import AuthMenu from "./AuthMenu";
import AdminMenu from "./AdminMenu";

// data
import { getAuthAccountLinks, getAuthCreatorToolsLinks } from "data/links";

export const ACCOUNT_TEST_ID = "account-menu-links";
export const CREATOR_TOOLS_TEST_ID = "creator-tools-menu-links";

// component
const AuthMenus = () => {
    const { currentUser, authMenuVisibilitiy } = useSiteHeader();
    const { firstActiveTeam, creatorTools } = authMenuVisibilitiy;
    const { hasApiKey, getApiKeyStatus } = useApiStatus();

    /**
     * We removed hasApiKey from main user query
     * We now query for user's API key status only when they open the profile menu, as a specific call.
     * Fetch here, not in hook: this component is always mounted (hidden, not unmounted), so consumers must control when to fetch
     */
    useEffect(() => {
        if (currentUser?.id) {
            getApiKeyStatus();
        }
    }, [currentUser?.id]);

    return (
        <>
            <AuthMenu
                id={ACCOUNT_TEST_ID}
                menu={getAuthAccountLinks({
                    currentUser,
                    firstActiveTeam,
                    hasApiKey,
                })}
            />
            {creatorTools?.showMenu && (
                <AuthMenu
                    id={CREATOR_TOOLS_TEST_ID}
                    menu={getAuthCreatorToolsLinks({
                        currentUser,
                        creatorTools,
                    })}
                />
            )}
            <AdminMenu />
        </>
    );
};

export default AuthMenus;
